module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/suns_sand_3-00d46eb25578d7b1d4a635a4cd1d9af2.png";